export default function Canvas_Text() {
  return (
    <div>
      <h1>Canvas_Text Component</h1>
    </div>
  );
}
